export const MESSAGE_PAUSE_TIME = 3000;
export const SEARCH_DELAY = 300;
export const UPDATE_UNREAD_COMMENTS_DELAY = 60000;
export const DEFAULT_DATE_INPUT_FORMAT = "YYYY-MM-DD";
